import { Component } from 'react';
import cx from 'classnames';
import * as HighCharts from 'highcharts';
import f2sInvestStyles from '../../styles/whatsapp-confirmation/index.scss';
// import {
//   plan19ROI3Years,
//   plan26ROI3Years,
// } from './../../constants/fundBuckets/other';
import { Api } from '../../api';
import { generateOrderGenDate } from '../../utils/cartUtils';

interface Props {
  bucketDetails: any;
  url: any;
  showYaxis?: boolean;
  hideTitle?: boolean;
  showSingleFund?: boolean; // keep false by default
}

interface State {
  year: number;
  graphData: any[];
  startDate: string;
  endDate: string;
  returns: string;
}

const api = new Api();

class PlanReturnGraph extends Component<Props, State> {
  private chart: any;
  constructor(props: Props) {
    super(props);

    this.state = {
      year: 5,
      graphData: null,
      startDate: generateOrderGenDate(this.getDate(-5)), // keep it same as year
      endDate: generateOrderGenDate(this.getDate(0)),
      returns: props.bucketDetails.sections.planSummary.returns.return5yr || 0,
    };
  }

  private renderChart = () => {
    const { graphData } = this.state;
    const { showYaxis = true } = this.props;
    this.chart = new HighCharts.chart('planHistoryChart', {
      chart: {
        type: 'spline',
        scrollablePlotArea: {
          minWidth: 600,
          scrollPositionX: 1,
        },
      },
      title: {
        text: '',
        align: 'left',
      },
      xAxis: {
        type: 'datetime',
        labels: {
          overflow: 'justify',
        },
        enabled: false,
      },
      yAxis: {
        title: {
          text: '',
        },
        minorGridLineWidth: 0,
        gridLineWidth: 0,
        alternateGridColor: null,
        visible: showYaxis,
      },
      tooltip: {
        valuePrefix: '₹',
      },
      plotOptions: {
        spline: {
          lineWidth: 4,
          states: {
            hover: {
              lineWidth: 5,
            },
          },
          marker: {
            enabled: false,
          },
        },
      },
      series: [
        {
          name: 'Net Value',
          data: graphData,
          showInLegend: false,
        },
      ],
      navigation: {
        menuItemStyle: {
          fontSize: '10px',
        },
      },
    });
  };

  private getFundDetails = (products: any, isinCode: string) => {
    return products.filter(product => {
      return product.fundMetaData.isinCode === isinCode;
    });
  };

  private getFundReturn = (products: any, isinCode: string) => {
    const fundDetails = this.getFundDetails(products, isinCode);
    const { fundMetaData } = fundDetails[0];
    const { returns } = fundMetaData;
    return returns;
  };

  private handleYearChange = (e: any) => {
    const { bucketDetails, showSingleFund = false } = this.props;
    const { value } = e.target;
    const year = value === 'all' ? 20 : parseInt(value, 10);
    const returns = this.handleSingleFundReturn(
      bucketDetails,
      showSingleFund,
      year
    );
    this.setState(
      {
        year,
        returns,
        startDate: generateOrderGenDate(this.getDate(-year)),
      },
      () => {
        this.generateGraphData();
      }
    );
  };

  private generateGraphData = async (props?: Props) => {
    const { bucketDetails, showSingleFund = false } = this.props;
    let products = bucketDetails.products;

    // if props is empty
    if (!products.length && props.bucketDetails.products.length) {
      products = props.bucketDetails.products;
    }

    const isinCodeArr = [];
    if (showSingleFund) {
      if (bucketDetails && bucketDetails.sections.bucketId === '19') {
        isinCodeArr.push('INF846K01EW2');
      } else {
        isinCodeArr.push('INF200K01QX4');
      }
    } else {
      products.forEach(fund => {
        isinCodeArr.push(fund.isinCode);
      });
    }
    products.forEach(fund => {
      isinCodeArr.push(fund.isinCode);
    });

    const { endDate, startDate } = this.state;
    await api.getGraphData(startDate, endDate, isinCodeArr).then(res => {
      const graphData = [];
      for (const data of Object.keys(res)) {
        const dateData = data.split('-');
        const year = +dateData[0];
        const month = +dateData[1] - 1;
        const date = +dateData[2];
        graphData.push([
          Date.UTC(year, month, date),
          +(res[data] * 150000).toFixed(2),
        ]);
      }
      this.setState(
        {
          graphData,
        },
        this.renderChart
      );
    });

    // const amountData = (planId === '19'
    //   ? plan19ROI3Years
    //   : plan26ROI3Years
    // ).map((data: any) => {
    //   const dateData = data.date.split('-');
    //   const year = +dateData[0];
    //   const month = +dateData[1] - 1;
    //   const date = +dateData[2];
    //   return [Date.UTC(year, month, date), +(data.ROI * 150000).toFixed(2)];
    // });
    // this.setState(
    //   {
    //     graphData: amountData,
    //   },
    //   this.renderChart
    // );
  };

  private renderInvestmentPeriod() {
    const { year } = this.state;
    const yearsArr = [3, 5];
    return yearsArr.map((yr, index) => {
      return (
        <button
          type="button"
          className={cx(
            'btn btn-small text--uppercase text--md',
            f2sInvestStyles['btn'],
            f2sInvestStyles['small'],
            {
              [f2sInvestStyles['selected']]: year === yr,
            }
          )}
          name="year"
          value={yr}
          onClick={this.handleYearChange}
          key={index}
        >
          {yr === 20 ? 'all' : `${yr}Y`}
        </button>
      );
    });
  }

  private getDate = (yearFromCurrentYear: number) => {
    return new Date(
      new Date().setFullYear(new Date().getFullYear() + yearFromCurrentYear)
    );
  };

  private handleSingleFundReturn = (
    bucketDetails: any,
    showSingleFund: boolean,
    year: number
  ) => {
    const { bucketId } = bucketDetails.sections;
    let returns;
    if (showSingleFund) {
      const fundMetaDataReturn =
        bucketId === '19'
          ? this.getFundReturn(bucketDetails.products, 'INF846K01EW2')
          : this.getFundReturn(bucketDetails.products, 'INF200K01QX4');
      returns =
        year === 3
          ? fundMetaDataReturn.return3yr
          : fundMetaDataReturn.return5yr;
    } else {
      returns =
        year === 3
          ? bucketDetails.sections.planSummary.returns.return3yr
          : bucketDetails.sections.planSummary.returns.return5yr;
    }
    return returns;
  };

  public componentDidMount() {
    const { showSingleFund = false, bucketDetails } = this.props;
    const { year } = this.state;
    let returns;
    if (this.props.bucketDetails.products.length) {
      returns = this.handleSingleFundReturn(
        bucketDetails,
        showSingleFund,
        year
      );
      this.setState({ returns }, () => this.generateGraphData());
    }
  }

  public componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  public UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const { showSingleFund = false } = this.props;
    const { year } = this.state;

    if (
      this.props.bucketDetails.products.length !==
      nextProps.bucketDetails.products.length
    ) {
      let returns;
      returns = this.handleSingleFundReturn(
        nextProps.bucketDetails,
        showSingleFund,
        year
      );
      this.setState({ returns }, () => this.generateGraphData());
    }
  }

  public render() {
    const {
      bucketDetails: {
        sections: { title: bucketTitle },
      },
      bucketDetails,
      hideTitle = false,
      showSingleFund = false,
    } = this.props;
    const { products } = bucketDetails;
    const { year, returns } = this.state;
    let title;
    if (bucketDetails.sections.bucketId !== '') {
      if (bucketDetails.sections.bucketId === '26') {
        products.forEach(element => {
          if (element.fundMetaData.isinCode === 'INF200K01QX4') {
            title = element.fundName;
          }
        });
      } else {
        products.forEach(element => {
          if (element.fundMetaData.isinCode === 'INF846K01EW2') {
            title = element.fundName;
          }
        });
      }
    }
    return (
      <div className={cx(hideTitle ? null : 'p15')}>
        <div className={cx('row')}>
          <div className={cx('columns small-8')}>
            {hideTitle ? null : showSingleFund ? (
              <div className={cx('text--xlg font--bold font--grey mb5')}>
                {bucketDetails && bucketDetails.products.length ? title : ''}
              </div>
            ) : (
              <div className={cx('text--xlg font--bold font--grey mb5')}>
                {bucketTitle} plan
              </div>
            )}
            <div>
              See how <strong>₹1,50,000</strong> grew over{' '}
              {year === 20 ? null : 'last '}
              <strong>{year === 20 ? null : year} years</strong>
            </div>
          </div>

          <div className={cx('columns small-4 text-right')}>
            <div className={cx('inline-block text-left')}>
              <div className={cx('font--fadedgrey text--md')}>
                {year === 20 ? '5' : year}Y return
              </div>
              <div
                className={cx(
                  'text--xxxlg font--bold text--turquoise font--green'
                )}
              >
                {returns}%
              </div>
            </div>
          </div>

          <div className={cx('columns medium-12')}>
            <div id="planHistoryChart" />
            <div
              className={cx(
                f2sInvestStyles['form-btn-group'],
                f2sInvestStyles['shrink'],
                'margin-auto'
              )}
              role="group"
            >
              {this.renderInvestmentPeriod()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PlanReturnGraph;



// WEBPACK FOOTER //
// ./components/f2s/planReturnGraph.tsx